import React, { useState } from "react";
import { Link } from "react-router-dom";

import home_page from "../images/home_page_2.png";
import logo_nero from "../images/logoasterisco_nero.png";

import hover_speakeasy from "../images/stenzetta_1.JPG";
// import hover_info from "../images/hover_info_2.png";
import hover_info from "../images/info_info.png";
import hover_cucina from "../images/lampada.jpg";
import hover_piccola from "../images/piccola_tav_2.jpg";
import hover_giardino from "../images/garden_1.JPG";
import hover_eventi from "../images/grande_ads_2.jpg";
import hover_lagrande from "../images/lagrande_1.jpg";
import Logo from "./Logo";

export default function Home() {
  const [hoverImage, setHoverImage] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const infoHoverKey = "info";

  const setHover = (img) => img && setHoverImage(img);
  const clearHover = () => setHoverImage(null);
  const isInfoHover = hoverImage === infoHoverKey;

  const mobileMenuItems = [
    ["LE INFO", "/info", hover_info],
    ["GLI EVENTI", "/eventi", hover_eventi],
    ["LA CUCINA", "/lacucina", hover_cucina],
    ["IL GIARDINO", "/ilgiardino", hover_giardino],
    ["LA GRANDE", "/lagrande", hover_lagrande],
    ["LA PICCOLA", "/lapiccola", hover_piccola],
  ];

  return (
    <div className="relative w-screen h-screen bg-white text-black overflow-hidden font-[Inter]">
      {/* Background image inside proportional white frame */}
      <div className="absolute inset-[20px] lg:inset-[5vw] transition-all duration-500">
        {isInfoHover ? (
          <div className="flex h-full w-full items-center justify-center bg-black px-8 text-center text-white">
            <p className="max-w-3xl text-[clamp(18px,2.2vw,24px)] leading-snug">
              Un loft industriale, uno spazio eventi versatile e trasformabile.
              Accogliamo eventi esclusivi, sfilate di moda, cene private,
              vernissage, mostre d’arte e live performance.
            </p>
          </div>
        ) : (
          <img
            src={hoverImage || home_page}
            alt="Altrove"
            className="w-full h-full object-cover"
          />
        )}
      </div>

      {/* MOBILE / TABLET LAYOUT (<= lg) */}
      <div className="absolute inset-0 z-30 lg:hidden">
        <Link to="/" className="absolute top-4 left-4 sm:top-6 sm:left-6 z-50">
          <img
            src={logo_nero}
            alt="Altrove Logo"
            className="w-36 sm:w-40 h-auto"
          />
        </Link>
        <button
          type="button"
          onClick={() => setIsMobileMenuOpen((open) => !open)}
          className="absolute top-4 right-4 sm:top-6 sm:right-6 z-40 flex h-20 w-20 sm:h-22 sm:w-22 items-center justify-center rounded-full border border-black bg-white/90"
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
        >
          <span className="flex flex-col gap-1.5">
            <span className="block h-0.5 w-12 sm:w-14 bg-black"></span>
            <span className="block h-0.5 w-12 sm:w-14 bg-black"></span>
            <span className="block h-0.5 w-12 sm:w-14 bg-black"></span>
          </span>
        </button>
        {isMobileMenuOpen && (
          <div className="absolute inset-0 z-30 flex flex-col items-center justify-center bg-white/95 px-8 pb-12 pt-24">
            <nav className="flex flex-col items-center gap-20">
              {mobileMenuItems.map(([label, path, img]) => (
                <Link
                  key={path}
                  to={path}
                  onMouseEnter={() => setHover(img)}
                  onMouseLeave={clearHover}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className="text-center text-[28px] sm:text-[32px] leading-none hover:underline"
                >
                  {label}
                </Link>
              ))}
            </nav>
          </div>
        )}
      </div>

      {/* DESKTOP LAYOUT (>= lg) */}
      <div className="hidden lg:block absolute inset-0 z-30 pointer-events-none">
        {/* LOGO TOP-LEFT (asterisk logo as in mockup) */}
        <Link
          to="/"
          className="absolute top-[1.5%] left-[1%] pointer-events-auto"
        >
          <img
            src={logo_nero}
            alt="Altrove Logo"
            className="w-[10vw] min-w-[40px] max-w-[180px] h-auto  "
          />
        </Link>

        {/* TOP MENU: LE INFO, GLI EVENTI, LA CUCINA */}
        <MenuItem
          label="LE INFO"
          path="/info"
          hoverImg={infoHoverKey}
          className="absolute top-[0%] left-[40%] -translate-x-1/2"
          setHover={setHover}
          clearHover={clearHover}
        />
        <MenuItem
          label="GLI EVENTI"
          path="/eventi"
          hoverImg={hover_eventi}
          className="absolute top-[0%] left-[80%] -translate-x-1/2"
          setHover={setHover}
          clearHover={clearHover}
        />
        {/* <MenuItem
          label="LA STANZETTA "
          path="/lastanzetta"
          hoverImg={hover_stanzetta}
          className="absolute top-[0%] left-[86%] -translate-x-1/2"
          setHover={setHover}
          clearHover={clearHover}
        /> */}

        {/* LEFT VERTICAL: LA PICCOLA */}
        <MenuItem
          label="LA PICCOLA"
          path="/lapiccola"
          hoverImg={hover_piccola}
          className="absolute left-[-11%] bottom-[20%] -translate-y-1/2 -rotate-90 origin-center"
          setHover={setHover}
          clearHover={clearHover}
        />

        {/* RIGHT VERTICAL: LA STANZETTA */}
        <MenuItem
          label="LA CUCINA"
          path="/lacucina"
          hoverImg={hover_cucina}
          className="absolute right-[-10%] bottom-[27%] -translate-y-1/2 rotate-90 origin-center"
          setHover={setHover}
          clearHover={clearHover}
        />

        {/* BOTTOM MENU: LA GRANDE & IL GIARDINO */}
        <MenuItem
          label="LA GRANDE"
          path="/lagrande"
          hoverImg={hover_lagrande}
          className="absolute bottom-[0%] left-[30%] -translate-x-1/2"
          setHover={setHover}
          clearHover={clearHover}
        />
        <MenuItem
          label="IL GIARDINO"
          path="/ilgiardino"
          hoverImg={hover_giardino}
          className="absolute bottom-[0%] left-[75%] -translate-x-1/2"
          setHover={setHover}
          clearHover={clearHover}
        />
      </div>
    </div>
  );
}

/**
 * Desktop menu item – proportional typography & positioning
 */
function MenuItem({ label, path, hoverImg, className, setHover, clearHover }) {
  return (
    <Link
      to={path}
      onMouseEnter={() => setHover(hoverImg)}
      onMouseLeave={clearHover}
      className={`${className} pointer-events-auto`}
    >
      <span className="font-normal leading-none hover:underline text-[clamp(48px,4.7vw,90px)] whitespace-nowrap">
        {label}
      </span>
    </Link>
  );
}
